import React from 'react';
import { DataContext } from '../DataProvider/DataProvider';
import styled from 'styled-components';

function RepertoireList() {
  const {
    repertoires,
    currentRepertoireId,
    loadRepertoire,
    createRepertoire,
    deleteRepertoire,
  } = React.useContext(DataContext);

  const handleCreate = async () => {
    const name = prompt('Enter the name for the new repertoire:');
    if (name && name.trim() !== '') {
      try {
        await createRepertoire(name.trim());
      } catch (error) {
        alert('Failed to create repertoire. Please try again.');
      }
    }
  };

  const handleDelete = async (id, name) => {
    if (window.confirm(`Are you sure you want to delete "${name}"?`)) {
      try {
        await deleteRepertoire(id);
      } catch (error) {
        alert('Failed to delete repertoire. Please try again.');
      }
    }
  };

  return (
    <Wrapper>
      <Header>
        <h3>Repertoires</h3>
        <CreateButton onClick={handleCreate} title='Create New Repertoire'>
          +
        </CreateButton>
      </Header>
      <List>
        {repertoires.map((repertoire) => (
          <ListItem
            key={repertoire.id}
            $active={repertoire.id === currentRepertoireId}
            onClick={() => loadRepertoire(repertoire.id)}
          >
            <Name>{repertoire.name}</Name>
            <DeleteButton
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(repertoire.id, repertoire.name);
              }}
              title='Delete'
            >
              &times;
            </DeleteButton>
          </ListItem>
        ))}
      </List>
    </Wrapper>
  );
}

export default RepertoireList;

const Wrapper = styled.div`
  padding: 20px 22px 22px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
`;

const CreateButton = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
  cursor: pointer;
  color: var(--accent-strong);
  background: rgba(159, 109, 76, 0.12);
  border: 1px solid rgba(159, 109, 76, 0.18);
  border-radius: 999px;
  transition:
    transform 0.2s ease,
    background 0.2s ease;

  &:hover {
    background: rgba(159, 109, 76, 0.18);
    transform: translateY(-1px);
  }
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
`;

const ListItem = styled.li`
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  border: 1px solid
    ${(props) =>
      props.$active ? 'rgba(159, 109, 76, 0.28)' : 'var(--border)'};
  background: ${(props) =>
    props.$active ? 'rgba(159, 109, 76, 0.12)' : 'rgba(255, 249, 241, 0.88)'};
  color: ${(props) => (props.$active ? 'var(--accent-strong)' : 'var(--text)')};
  min-width: 180px;
  transition:
    transform 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    background: ${(props) =>
      props.$active ? 'rgba(159, 109, 76, 0.18)' : 'rgba(239, 228, 213, 0.92)'};
    transform: translateY(-1px);
    box-shadow: 0 12px 20px rgba(86, 62, 43, 0.08);
  }
`;

const Name = styled.span`
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
`;

const DeleteButton = styled.button`
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(124, 98, 74, 0.14);
  border-radius: 999px;
  cursor: pointer;
  color: inherit;
  opacity: 0.6;
  &:hover {
    opacity: 1;
    color: var(--danger);
  }
`;
